import useCustomHook from '@/hooks/useCustomHook';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import startFreeTrial from '@/api/subscriptions/startFreeTrial.endpoint';
import openAPIErrorNotification from '@/shared/APIErrorNotification/APIErrorNotification';
import { notification } from 'antd';
import { useContext } from 'react';
import setAuthenticatedUser from 'src/modules/auth/setAuthenticatedUser';
import recreateAccessToken from '@/api/auth/recreateAccessToken.endpoint';

export default function useStartFreeTrialButton({
  subscriptionTypeId,
  onFinish,
}) {
  const globalContext = useContext(GlobalContext);
  const { state, actions } = useCustomHook({
    defaultState: {
      loading: true,
      subscription: null,
      processing: false,
    },
    actions: {
      startFreeTrial: async () => {
        try {
          actions.setState({ processing: true });
          await startFreeTrial(subscriptionTypeId);
          const response = await recreateAccessToken();
          await setAuthenticatedUser({
            accessToken: response.token,
            context: globalContext,
          });
          notification.success({
            message: 'Trial started',
            description: 'Enjoy Rockalingua!',
          });
          onFinish();
          actions.setState({ processing: false });
        } catch (e) {
          actions.setState({ processing: false });
          openAPIErrorNotification({
            title: 'There was an error',
            description: 'There was a problem starting free trial',
            errorFeedback: e.feedbackData,
          });
        }
      },
    },
  });

  return { state, actions };
}
